// @core/api/endpoints/payment/get_contract_requisites_for_legal_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetContractRequisitesForLegalEntityResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Resolve contract-ready bank requisites for a legal entity
 * Returns the full BankAccountRequisites block ready for embedding into a contract preamble or signature page. Resolves via the chain LegalEntity → BillingAccount(s) → active PaymentMethodDetail filtered by currency. Optional billing_account override picks a specific BillingAccount instead of the default per currency.
 */
export async function GetContractRequisitesForLegalEntity(
  legalEntityId: string,
  options?: RequestOptions
): Promise<GetContractRequisitesForLegalEntityResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/legal-entities/:legalEntityId/contract-requisites`;
  requestPath = requestPath.replace(':legalEntityId', encodeURIComponent(legalEntityId));
  const requestOptions = options;
  return client.get<GetContractRequisitesForLegalEntityResponse>(requestPath, { ...requestOptions });
}
